<template>
    <div class="StoreWrap">
        <!-- 别人的主页和自己的主页分开写防止老板一顿改改乱了 -->
        <div class="PersonIndexBox" :class="{'hidden':PersonState}">
            <PersonIndex :PersonData="Person" @OpenPersonBox="OpenPersonIndex"></PersonIndex>
        </div>
        <div class="SwiperWrap">
            <i class="LeftShadow"><img src="../../assets/Home/LeftShadow.png"></i>
            <swiper class="SwiperList" ref="mySwiper" :options="swiperOptions">
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img_3.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img_1.jpg"></swiper-slide>
                <swiper-slide class="ImgWrap"><img src="../../assets/Home/Img_2.jpg"></swiper-slide>
                <div class="swiper-pagination flex" slot="pagination"></div>
            </swiper>
            <i class="RightShadow"><img src="../../assets/Home/RightShadow.png"></i>
        </div>
        <div class="TabContentWrap clearfix">
            <div class="Title flexa">
                <p>云产品</p>
                <router-link
                        tag="i"
                        :to="{ name: 'ProductList', params: { flag: 0 } }"
                ><img src="../../assets/Home/menu.png"
                /></router-link>
            </div>
            <ul>
                <li v-for="(item,index) in ProductData" :key="index" @click="ToDetail('ProductList',item.产品ID)">
                    <div class="IconWrap">
                        <img :src="item.logo图">
                        <div class="Name"><p>{{ item.名称 }}</p></div>
                        <div class="flexa Items"><span>{{ item.标签 }}</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="sixline">{{ item.详情介绍 }}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="TabContentWrap hidden clearfix">
            <div class="Title flexa">
                <p>云平台</p>
                <router-link
                        tag="i"
                        :to="{ name: 'ProductList1', params: { flag: 0 } }"
                ><img src="../../assets/Home/menu.png"
                /></router-link>
            </div>
            <ul>
                <li v-for="(item,index) in ProductData1" :key="index" @click="ToDetail('ProductList1',item.产品ID)">
                    <div class="IconWrap">
                        <img :src="item.logo图">
                        <div class="Name"><p>{{ item.名称 }}</p></div>
                        <div class="flexa Items"><span>{{ item.标签 }}</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="sixline">{{ item.详情介绍 }}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="TabContentWrap clearfix">
            <div class="Title flexa">
                <p>定制服务</p>
                <router-link
                        tag="i"
                        :to="{ name: 'ProductList2', params: { flag: 0 } }"
                ><img src="../../assets/Home/menu.png"
                /></router-link>
            </div>
            <ul>
                <li v-for="(item,index) in ProductData2" :key="index" @click="ToDetail('ProductList2',item.产品ID)">
                    <div class="IconWrap">
                        <img :src="item.logo图">
                        <div class="Name"><p>{{ item.名称 }}</p></div>
                        <div class="flexa Items"><span>{{ item.标签 }}</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="sixline">{{ item.详情介绍 }}</p>
                    </div>
                </li>
            </ul>
        </div>
       <!-- <div v-if="(this.flag===2)" class="PersonListWrap clearfix">
            <div class="PersonList">
                <ul class="clearfix">
                    <li v-for="(item,index) in PersonData" :key="index" class="flex" @click="OpenPersonIndex(item)">
                        <div class="PersonInfo">
                            <i>
                                <img v-if="item.头像" :src="item.头像">
                                <img v-else src="../../assets/defaulthead.png">
                            </i>
                            <div class="flex Star">
                                <img src="../../assets/Home/star.png">
                                <img src="../../assets/Home/star.png">
                                <img src="../../assets/Home/star.png">
                                <img src="../../assets/Home/star.png">
                                <img src="../../assets/Home/star.png">
                            </div>
                            <div class="Person flexbetween">
                                <p>{{ item.名称 }}</p>
                                <p v-if="item.标签">{{ item.标签.split(',')[0] }}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>-->
    </div>
</template>
<script>
  import PersonIndex from '../../components/PersonIndex';
  import { mapGetters } from 'vuex';
  export default {
    name: 'store',
    components: {
      PersonIndex
    },
    inject: [
      'load'
    ],
    data() {
      return {
        PersonState: 'true',
        /* 公司系统 */
        URL: 'https://model.goeasy.cn:8201/',
        /* K8S测试 */
        /*        URL: 'https://x6k8s.goeasy.cn/', */
        Person: {},
        PersonData: [
        ],
        ProductData: [],
        ProductData1: [],
        ProductData2: [],
        customstate: false,
        customdata: '',
        swiperOptions: {
          slidesPerView: 1.13,
          centeredSlides: true,
          spaceBetween: 15,
          initialSlide: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination'
          }
        }
      };
    },
    created() {
      this.GetProductList();
      this.GetProductList1();
      this.GetProductList2();
    },
    methods: {
      /* 获取商品列表 */
      GetProductList() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007001',
            userId: 'CommonUser_ixuOYxkPy78='
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.ProductData = res.data.data.DETAIL.slice(0, 6);
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 获取平台列表 */
      GetProductList1() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007033',
            userId: 'CommonUser_ixuOYxkPy78='
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.ProductData1 = res.data.data.DETAIL.slice(0, 3);
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 获取定制列表 */
      GetProductList2() {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007037',
            userId: 'CommonUser_ixuOYxkPy78='
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.ProductData2 = res.data.data.DETAIL.slice(0, 6);
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      CloseCustomBox() {
        this.customstate = false;
      },
      OpenPersonIndex(val) {
        this.PersonState = !this.PersonState;
        if (val) {
          this.Person = val;
        }
      },
      ToCustomization(Data) {
        this.customstate = true;
        this.customdata = Data;
      },
      ToDetail(name, Data) {
        this.$router.push({
          name: name,
          params: { id: Data }
        });
      }
    },
    computed: {
      ...mapGetters(['LoginUserInfo'])
    }

  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .StoreWrap{
        width: 100%;
        .PersonIndexBox{
            width: 46%;
            height: calc(100% - 0.7rem);
            position: fixed;
            left: 27%;
            bottom: 0;
            z-index: 4;
        }
        .CustomizationBox{
            background-color: #000;
            width: 50%;
            left: 25%;
            height: calc(100% - 0.7rem);
            position: fixed;
            z-index: 3;
            bottom: 0;
        }
        .PersonList{
            width: 100%;
            ul{
                width: 100%;
                li.Last{
                    div{
                        width: 100%;
                        height: 100%;
                        cursor: pointer;
                        img{
                            width: 0.15rem;
                        }
                    }
                }
                li{
                    width: 23.4%;
                    height: 1.2rem;
                    background-color: #282828;
                    margin-right: 2%;
                    margin-bottom: 2%;
                    border-radius: 0.1rem;
                    float: left;
                    cursor: pointer;
                    .PersonInfo{
                        width: 0.6rem;
                        height: 1rem;
                        .Person{
                            width: 100%;
                            margin-top: 0.14rem;
                            border-bottom: 1px solid #fff;
                            padding-bottom: 0.03rem;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                                margin: 0 0.02rem;
                            }
                            p:last-child{
                                font-size: $SmallTextSize;
                                opacity: 0.6;
                            }
                        }
                        .Star{
                            width: 100%;
                            margin-top: 0.075rem;
                            img{
                                width: 0.08rem;
                                margin: 0 0.02rem;
                            }
                        }
                        i{
                            width: 0.6rem;
                            height: 0.6rem;
                            border-radius: 0.1rem;
                            img{
                                width: 100%;
                                height: 100%;
                                border-radius: 0.1rem;
                                object-fit: cover;
                            }
                        }
                    }
                }
                li:nth-child(4n){
                    margin-right: 0;
                }
            }
        }
        .PersonListWrap{
            width: 88%;
            margin: 0 auto;
        }
        .TabContentWrap{
            width: 88%;
            margin: 0 auto;
            .Title {
                width: 100%;
                margin: 0 auto;
                position: relative;
                height: 0.3rem;
                margin-top: 0.1rem;
                p {
                    font-size: $TitleSize;
                    color: #fff;
                    position: absolute;
                    left: 0;
                    font-weight: bold;
                }
                i {
                    width: 0.08rem;
                    position: absolute;
                    right: 0;
                    cursor: pointer;
                    img {
                        width: 100%;
                    }
                }
            }
            ul{
                width: 100%;
                li{
                    width: 32%;
                    height: 1.3rem;
                    background-color: #fff;
                    border-radius: 0.1rem;
                    float: left;
                    margin-right: 2%;
                    margin-bottom: 2%;
                    position: relative;
                    cursor: pointer;
                    .Buttons{
                        width: 100%;
                        position: absolute;
                        bottom: 0.08rem;
                        left: 0;
                        div{
                            cursor: pointer;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                            }
                        }
                        div:first-child{
                            width: 0.3rem;
                            height: 0.13rem;
                            border-radius: 0.4rem;
                            background-color: #8c73b5;
                            margin: 0 0.09rem;
                        }
                        div:last-child{
                            width: 0.48rem;
                            height: 0.13rem;
                            border-radius: 0.4rem;
                            background-color: #cc9933;
                        }
                    }
                    .TextWrap{
                        width: 82%;
                        margin: 0.1rem auto 0;
                        p{
                            font-size: $AdditionTextSize;
                            color: #414141;
                            line-height: 0.075rem;
                        }
                    }
                    .IconWrap{
                        margin: 0.1rem 0 0 0.1rem;
                        img{
                            width: 0.25rem;
                            border-radius: 0.05rem;
                        }
                        .Name{
                            margin: 0.03rem 0;
                            p{
                                font-size: $TextSize;
                                color: #000;
                                font-weight: bold;
                            }
                        }
                        .Items{
                            span{
                                font-size: $SmallTextSize;
                                color: #999999;
                                margin-right: 0.02rem;
                            }
                        }
                    }
                }
                li:nth-child(3n){
                    margin-right: 0;
                }
            }
        }
        .SwiperWrap {
            width: 100%;
            height: 1.3rem;
            position: relative;
            overflow: hidden;
            .swiper-pagination {
                width: 100%;
                height: 0.1rem;
                position: absolute;
                bottom: 0.02rem;
                ::v-deep .swiper-pagination-bullet-active {
                    background-color: #fff !important;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 0.15rem;
                    height: 0.02rem;
                    opacity: 1;
                    margin: 0 0.02rem;
                    background-color: #4d4d4d;
                    border-radius: 0.03rem;
                }
            }

            .LeftShadow, .RightShadow {
                height: 100%;
                position: absolute;
                z-index: 2;

                img {
                    height: 100%;
                    transform: scale(1.1);
                }
            }

            .LeftShadow {
                left: -0.1rem;
                top: 0;
            }

            .RightShadow {
                right: -0.1rem;
                top: 0;
            }

            .SwiperList {
                width: 100%;
                height: 100%;

                .ImgWrap {
                    border-radius: 0.1rem;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 0.1rem;
                    }
                }
            }
        }
    }
</style>
